"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultDateTimeFormat = exports.IntlDateFormatOptions = void 0;
var IntlDateFormatOptions;
(function (IntlDateFormatOptions) {
    IntlDateFormatOptions["NUMERIC"] = "numeric";
    IntlDateFormatOptions["SHORT"] = "short";
    IntlDateFormatOptions["MEDIUM"] = "medium";
    IntlDateFormatOptions["LONG"] = "long";
    IntlDateFormatOptions["FULL"] = "full";
})(IntlDateFormatOptions = exports.IntlDateFormatOptions || (exports.IntlDateFormatOptions = {}));
var DefaultDateTimeFormat = /** @class */ (function () {
    function DefaultDateTimeFormat(value) {
        this.value = value;
    }
    // returns day of week, month, and date in a short form
    // ex: en-US returns "Tue, Apr 13"
    // tslint:disable-next-line:max-line-length
    DefaultDateTimeFormat.DAY_OF_WEEK_MONTH_DATE_SHORT = new DefaultDateTimeFormat({
        weekday: IntlDateFormatOptions.SHORT,
        month: IntlDateFormatOptions.SHORT,
        day: IntlDateFormatOptions.NUMERIC,
    });
    // returns day of week, month, and date in a long form.
    // different from "short" because the week and month are fully expanded
    // to their full string representations
    // ex: en-US returns "Tuesday, April 13"
    // tslint:disable-next-line:max-line-length
    DefaultDateTimeFormat.DAY_OF_WEEK_MONTH_DATE_LONG = new DefaultDateTimeFormat({
        weekday: IntlDateFormatOptions.LONG,
        month: IntlDateFormatOptions.LONG,
        day: IntlDateFormatOptions.NUMERIC,
    });
    // returns month, and date in a short form
    // ex: en-US returns "Apr 13"
    DefaultDateTimeFormat.MONTH_DATE_SHORT = new DefaultDateTimeFormat({
        month: IntlDateFormatOptions.SHORT,
        day: IntlDateFormatOptions.NUMERIC,
    });
    // returns month, and date in a long form
    // different from "short" because the month is fully expanded to its
    // full string representation
    // ex: en-US returns "April 13"
    DefaultDateTimeFormat.MONTH_DATE_LONG = new DefaultDateTimeFormat({
        month: IntlDateFormatOptions.LONG,
        day: IntlDateFormatOptions.NUMERIC,
    });
    // returns time in a 12h format
    // ex: en-US returns "10:50 PM"
    // ex: de-DE returns "22:50"
    DefaultDateTimeFormat.TIME = new DefaultDateTimeFormat({
        hour: IntlDateFormatOptions.NUMERIC,
        minute: IntlDateFormatOptions.NUMERIC,
    });
    // returns time in a 12h format with timezone
    // ex: en-US returns "10:50 PM PST"
    // ex: de-DE returns ""
    DefaultDateTimeFormat.TIME_WITH_ZONE = new DefaultDateTimeFormat({
        hour: IntlDateFormatOptions.NUMERIC,
        minute: IntlDateFormatOptions.NUMERIC,
        timeZoneName: IntlDateFormatOptions.SHORT,
    });
    // returns date + time in long format
    // ex: en-US returns "April 13, 2021, 8:14 AM PDT"
    // ex: de-DE returns "12. Oktober 2021, 16:01 GMT-7"
    DefaultDateTimeFormat.DATE_TIME_LONG = new DefaultDateTimeFormat({
        month: IntlDateFormatOptions.LONG,
        day: IntlDateFormatOptions.NUMERIC,
        year: IntlDateFormatOptions.NUMERIC,
        hour: IntlDateFormatOptions.NUMERIC,
        minute: IntlDateFormatOptions.NUMERIC,
        timeZoneName: IntlDateFormatOptions.SHORT,
    });
    // returns date + time in short format
    // ex: en-US returns "Apr 13, 2021, 8:14 AM"
    // ex: de-DE returns "12. Okt. 2021, 16:02"
    DefaultDateTimeFormat.DATE_TIME_SHORT = new DefaultDateTimeFormat({
        month: IntlDateFormatOptions.SHORT,
        day: IntlDateFormatOptions.NUMERIC,
        year: IntlDateFormatOptions.NUMERIC,
        hour: IntlDateFormatOptions.NUMERIC,
        minute: IntlDateFormatOptions.NUMERIC,
    });
    // returns date in long format, time in short format
    // ex: en-US returns "April 13, 2021, 8:14 AM"
    // ex: de-DE returns "12. Oktober 2021, 16:03"
    DefaultDateTimeFormat.DATE_LONG_TIME_SHORT = new DefaultDateTimeFormat({
        month: IntlDateFormatOptions.LONG,
        day: IntlDateFormatOptions.NUMERIC,
        year: IntlDateFormatOptions.NUMERIC,
        hour: IntlDateFormatOptions.NUMERIC,
        minute: IntlDateFormatOptions.NUMERIC,
    });
    // returns date in numeric format
    // ex: en-US returns "4/13/2021"
    DefaultDateTimeFormat.DATE_NUMERIC = new DefaultDateTimeFormat({
        month: IntlDateFormatOptions.NUMERIC,
        day: IntlDateFormatOptions.NUMERIC,
        year: IntlDateFormatOptions.NUMERIC,
    });
    return DefaultDateTimeFormat;
}());
exports.DefaultDateTimeFormat = DefaultDateTimeFormat;
